module.exports = __webpack_public_path__ + "img/Artboard3.4abb673a.png";